import { UnifiedUser } from "@/types/unified-user";
import { FileText } from "lucide-react";

interface UserAuditTabProps {
  user: UnifiedUser;
}

export function UserAuditTab({ user }: UserAuditTabProps) {
  // Audit logs would come from API in real implementation
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <FileText className="w-12 h-12 text-muted-foreground mb-4" />
      <h3 className="text-lg font-semibold mb-2">Audit Log</h3>
      <p className="text-muted-foreground max-w-sm">
        Audit logging is coming soon. This will show all changes made to this user account.
      </p>
    </div>
  );
}
